export const CSSClasses = {
  ALIGN_RIGHT: "input-align-right",
  BUTTON: "pr-form-field__button",
  BUTTON_DEV_PRIMARY: "pr-form-field__button pr-button__dev-primary",
  BUTTON_DEV_PRIMARY_OUTLINE: "pr-form-field__button pr-button__dev-primary-outline",
  BUTTON_DEV_DANGER: "pr-form-field__button pr-button__dev-danger",
  BUTTON_DEV_DANGER_OUTLINE: "pr-form-field__button pr-button__dev-danger-outline",
  BUTTON_PLOOKUP_PRIMARY: "pr-form-field__button--lookup pr-button__dev-primary",
  BUTTON_PRIME_DANGER: "pr-form-field__button pr-button__prime-danger",
  BUTTON_PRIME_DANGER_OUTLINE: "pr-form-field__button pr-button__prime-danger-outline",
  BUTTON_PRIME_PRIMARY: "pr-form-field__button pr-button__prime-primary",
  BUTTON_PRIME_PRIMARY_OUTLINE: "pr-form-field__button pr-button__prime-primary-outline",
  BUTTON_PRINT: "pr-form-field__button-print",
  CHECKBOX: "pr-form-field__checkbox",
  DATEBOX: "pr-form-field__datebox",
  FOOTER: "pr-footer",
  FOOTER_INFO: "pr-footer__info",
  FOOTER_INFO_TITLE: "pr-footer__info--title",
  FORM_FIELD_TITLE: "pr-form-field__title",
  FORM_FIELD_TITLE_ICON: "pr-form-field__title-icon",
  FORM_FIELD_TITLE_ICON_DEV: "pr-form-field__title-icon--devexpress",
  FORM_TITLE: "pr-form__title",
  FORM_TITLE_2: "pr-form__title-2",
  ICON_ACCEPT: "pi pi-check",
  ICON_CANCEL: "pi pi-times",
  ICON_CLEAR: "clear",
  ICON_CLOSE: "close",
  ICON_COLUMNCHOOSER: "columnchooser",
  ICON_GROUP: "group",
  ICON_MONEY: "money",
  ICON_MORE: "more",
  ICON_PREFERENCES: "preferences",
  ICON_SAVE: "save",
  ICON_SEARCH: "search",
  ICON_UNDO: "undo",
  ICON_UPLOAD: "upload",
  ICON_USER: "user",
  ICON_WARNING: "warning",
  ICON_XLS: "xlsfile",
  ITEM_CONTENT: "dx-item-content",
  LOOKUPEDITSELECTION: "pr-form-field__dropdown",
  NUMBERBOX: "pr-form-field__numberbox input-align-right input",
  NUMBERBOX2: "pr-form-field__numberbox",
  PADDING_GROUP: "PaddingGroup",
  PAGEHEADERBAR_TITLE_BUTTON: "pr-page-header-bar__title-button",
  PAGEHEADERBAR_TITLE_GRID_BUTTON: "pr-page-header-bar__title-grid-button",
  PAGEHEADERBAR_TITLE_GRID_BUTTON_CUSTOMFILTER: "pr-page-header-bar__title-grid-button-customfilter",
  PAGEHEADERBAR_TITLE_GRID_ICON: "pr-page-header-bar__title-grid-icon",
  PAGEHEADERBAR_TITLE_ICON: "pr-page-header-bar__title-icon",
  PLOOKUP: "pr-form-field__dropdown",
  POPUP_ITEM_HEIGHT: "pr-popup-item__height",
  POPUP_ITEM_HEIGHT_MARGIN: "pr-popup-item__height pr-popup-item__margin",
  RADIO_GROUP: "pr-form-field__radio-group",
  SELECTBOX: "pr-form-field__dropdown",
  TEXTAREA_NOWRAP: "pr-form-field__text-area-nowrap",
  TEXTAREA1: "pr-form-field__text-area-1",
  TEXTAREA2: "pr-form-field__text-area-2",
  TEXTAREA3: "pr-form-field__text-area-3",
  TEXTAREA4: "pr-form-field__text-area-4",
  TEXTAREA5: "pr-form-field__text-area-5",
  TEXTAREA6: "pr-form-field__text-area-6",
  TEXTAREA7: "pr-form-field__text-area-7",
  TEXTAREA8: "pr-form-field__text-area-8",
  TEXTBOX: "pr-form-field__textbox",
  TEXTBOX_PLOOKUP: "pr-form-field__textbox-plookup",
  UI_ALIGN_BLOCK: "pr-ui__aligment-block",
  TEXTAREA_BOLD: "pr-form-field__text-area-bold",
  VALIDATION_SUMARRY: "pr-form-field__validation-summary",
  LIST_2_COL: "pr-form-field__list-2",
  LIST_3_COL: "pr-form-field__list-3",
  LIST_4_COL: "pr-form-field__list-4",
};
